// extracted by mini-css-extract-plugin
export default {"leftWrap":"RemoveService_leftWrap__Kd6JJ","train":"RemoveService_train__o5xAP","removeBtn":"RemoveService_removeBtn__KWn94"};